module.exports = __webpack_public_path__ + "img/wifi_signal_1.5c34d7ac.svg";